import React from "react"

import * as style from "./Tab.module.scss"

// A single tab in a set of tabs
const Tab = ({
  children,
  label,
  data: {
    state: { selected },
    onSelection,
  },
}) => (
  <div className={style.tab}>
    <a onClick={() => onSelection(label)} data-style="block">
      {label}
    </a>
    {(selected === null || selected === label) && <section>{children}</section>}
  </div>
)

export default Tab
